import { BoardList } from "../components/BoardList";

export default function ExecutiveBoard() {
    return (
        <div className="container py-3">
            <div className="row justify-content-center">
                <h2 className="text-center">Executive Board</h2>
                <BoardList/>
            </div>
        </div>
    );
}